export default {
  tenant(state, getters, rootState) {
    return state.data.find(x => x.id === rootState.tenantId);
  }
};
